import React, { useState, useEffect } from 'react'
import './header.css'
import PropTypes from 'prop-types'
import Hidden from '@material-ui/core/Hidden'
import Drawer from '@material-ui/core/Drawer'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import {
  AppBar,
  Toolbar,
  CssBaseline,
  useScrollTrigger,
  Box,
  Container,
  Slide,
} from '@material-ui/core'
import NavLink from '../../../Helpers/NavLink/NavLink'
import { NavLink_Data, NavLink_Data_Footer } from '../../../Constants/Data_Json'
import { useHistory, useLocation } from 'react-router'
import Banner from './Component/Banner'
import SecondHeader from './Component/SecondHeader'
import ProfileDrop from './Component/ProfileDrop'
import Typography from '@material-ui/core/Typography'
import MenuIcon from '@material-ui/icons/Menu'
import Divider from '@material-ui/core/Divider'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import { makeStyles, useTheme } from '@material-ui/core'
const drawerWidth = 270
const Header = (props) => {
  const location = useLocation()
  const classes = loginStyles()
  const history = useHistory()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const HideOnScroll = (props) => {
    const { children, window } = props
    const trigger = useScrollTrigger({ target: window ? window() : undefined })
    return (
      <Slide appear={false} direction='down' in={!trigger}>
        {children}
      </Slide>
    )
  }

  HideOnScroll.propTypes = {
    children: PropTypes.element.isRequired,
    window: PropTypes.func,
  }

  const [state, setstate] = useState({
    breadCrum: [],
    Title: '',
  })

  const verifyLocation = () => {
    var obj = {}
    if (location.pathname === '/about') {
      obj = {
        id: '2',
        label: 'About',
        path: '/about',
      }
      setstate({ ...state, breadCrum: obj, Title: 'About' })
    } else if (location.pathname === '/contact') {
      obj = {
        id: '3',
        label: 'Contact Us',
        path: '/contact',
      }
      setstate({ ...state, breadCrum: obj, Title: 'Contact Us' })
    } else if (location.pathname.split('/')[1] === 'treatment-Details') {
      obj = {
        id: '3',
        label: 'Treatment Details',
        path: `/treatment-Details/${location.pathname.split('/')[2]}`,
      }
      setstate({ ...state, breadCrum: obj, Title: 'Treatment Details' })
    }
  }

  React.useEffect(() => {
    verifyLocation()
  }, [location.pathname])

  const [mobileOpen, setMobileOpen] = React.useState(false)
  const theme = useTheme()
  function handleDrawerToggle() {
    setMobileOpen(!mobileOpen)
  }

  return (
    <React.Fragment>
      <div className={classes.root}>
        {/* <CssBaseline /> */}
        <Hidden smDown implementation='css'>
          <HideOnScroll {...props}>
            <AppBar elevation={0}>
              <Container>
                <Toolbar>
                  <NavLink className={classes.title} to='/'>
                    <img src='/Img/MainLogo.svg' alt='logo' />
                  </NavLink>
                  <div className={classes.sectionDesktop}>
                    {localStorage.getItem('Token')
                      ? NavLink_Data_Footer.map((link, i) => (
                          <NavLink
                            className={
                              location.pathname === link.path
                                ? 'navLink navlinkActive'
                                : 'navLink'
                            }
                            key={i}
                            to={link.path}
                          >
                            {link.label}
                          </NavLink>
                        ))
                      : NavLink_Data.map((link, i) => (
                          <NavLink
                            className={
                              location.pathname === link.path
                                ? 'navLink navlinkActive'
                                : 'navLink'
                            }
                            key={i}
                            to={link.path}
                          >
                            {link.label}
                          </NavLink>
                        ))}
                  </div>
                  {localStorage.getItem('Token') ? <ProfileDrop /> : ''}
                </Toolbar>
              </Container>
            </AppBar>
          </HideOnScroll>
        </Hidden>
        <Hidden mdUp implementation='css'>
          <HideOnScroll {...props}>
            <AppBar elevation={0}>
              <Container>
                <Toolbar>
                  <IconButton
                    color='inherit'
                    aria-label='open drawer'
                    edge='start'
                    onClick={handleDrawerToggle}
                  >
                    <MenuIcon />
                  </IconButton>
                  <Typography variant='h6' noWrap>
                    Menus
                  </Typography>
                  <Drawer
                    className={classes.drawer}
                    variant='temporary'
                    anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    classes={{ paper: classes.drawerPaper }}
                    ModalProps={{
                      keepMounted: true, // Better open performance on mobile.
                    }}
                  >
                    <IconButton
                      onClick={handleDrawerToggle}
                      className={classes.closeMenuButton}
                    >
                      <CloseIcon />
                    </IconButton>
                    <div className={classes.drawerContainer}>
                      <List>
                        {localStorage.getItem('Token')
                          ? NavLink_Data_Footer.map((menu, i) => (
                              <ListItem
                                button
                                key={menu.text}
                                onClick={() => history.push(menu.path)}
                                className={
                                  location.pathname === menu.path
                                    ? 'navLink navlinkActive'
                                    : 'navLink'
                                }
                              >
                                <ListItemText>{menu.label}</ListItemText>
                              </ListItem>
                            ))
                          : NavLink_Data.map((menu, i) => (
                              <ListItem
                                button
                                key={menu.text}
                                onClick={() => history.push(menu.path)}
                                className={
                                  location.pathname === menu.path
                                    ? 'navLink navlinkActive'
                                    : 'navLink'
                                }
                              >
                                <ListItemText>{menu.label}</ListItemText>
                              </ListItem>
                            ))}
                        {/* <Divider /> */}
                        {localStorage.getItem('Token') ? (
                          <ListItem button key='drop'>
                            <ListItemIcon>
                              <ProfileDrop />
                            </ListItemIcon>
                          </ListItem>
                        ) : (
                          ''
                        )}
                      </List>
                    </div>
                  </Drawer>
                </Toolbar>
              </Container>
            </AppBar>
          </HideOnScroll>
        </Hidden>
        <Toolbar />
        {location.pathname === '/' ? (
          <Banner />
        ) : (
          <SecondHeader breadcrumb={state.breadCrum} Title={state.Title} />
        )}
      </div>
    </React.Fragment>
  )
}

const loginStyles = makeStyles((theme) => ({
  drawer: {
    [theme.breakpoints.up('md')]: {
      width: 270,
      flexShrink: 0,
    },
  },
  grow: {
    flexGrow: 1,
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  drawerContainer: {
    overflow: 'auto',
  },
  drawerPaper: {
    width: drawerWidth,
    paddingLeft: 8,
    paddingRight: 8,
  },
  closeMenuButton: {
    marginRight: 'auto',
    marginLeft: 0,
  },
}))

export default Header
